module.exports = __webpack_public_path__ + "img/1557697853.b375e450.jpg";